<template lang="html">
  <div v-if="items.length > 0" class="slider-wrapper">
    <div class="slider-title">
      <div class="category-name">
        <!-- {{this.category}} -->
        {{ getCategoryName(this.category) }}
      </div>
      <div class="line"></div>
      <div class="navigation-btn-wrapper">
        <div @click="navigate('left')" class="btn">
          <img src="@/assets/icons/sliderBtnLeft.png" alt="slider btn left" />
        </div>
        <div @click="navigate('right')" class="btn">
          <img src="@/assets/icons/sliderBtnRight.png" alt="slider btn right" />
        </div>
      </div>
    </div>
    <div ref="sliderWrapper" class="slider-content">
      <item :itemData="item" v-for="item in items" :key="item.id" />
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
import Item from '@/components/item/item.vue'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'slider',
  props: {
    category: {
      required: true,
      type: String,
      default: 'new'
    },
    group: {
      type: Number
    },
    similar: {
      required: false,
      type: Number
    },
    user: {
      required: false,
      type: Number
    }
  },
  components: {
    Item
  },
  data () {
    return {
      items: [],
      // categoryTranslation: this.$i18n.t(this.category)
      categoryTranslation: this.category
    }
  },
  mounted () {
    this.fetchItems()
    eventBus.$on('refresh', () => {
      this.fetchItems()
    })
  },
  activated () {
    this.fetchItems()
    eventBus.$on('refresh', () => {
      this.fetchItems()
    })
  },
  methods: {
    fetchItems () {
      if (this.similar) {
        api
          .getSimilarProducts(this.similar)
          .then(res => {
            this.items = res.data.data
          })
          .catch(e => {
            console.log(e)
          })
        return
      }
      if (this.user) {
        api
          .getUserProducts(this.user)
          .then(res => {
            this.items = res.data.data
          })
          .catch(e => {
            console.log(e)
          })
        return
      }
      if (this.group === 1) {
        api
          .getGroupNew()
          .then(res => {
            this.items = res.data.data
          })
          .catch(e => {
            console.log(e)
          })
      } else if (this.group === 2) {
        api
          .getGroupPopular()
          .then(res => {
            this.items = res.data.data
          })
          .catch(e => {
            console.log(e)
          })
      } else {
        api
          .getGroupProducts(this.group)
          .then(res => {
            this.items = res.data.data
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    navigate (direction) {
      let el = this.$refs.sliderWrapper
      let itemWidth = 282
      let itemsShown = Math.ceil(el.clientWidth / itemWidth)
      if (direction === 'right') {
        el.scrollLeft += itemWidth * (itemsShown - 1)
      } else {
        el.scrollLeft -= itemWidth * (itemsShown - 1)
      }
    },
    getCategoryName (name) {
      // if (name === 'Najtraženije' || name === 'Najnovije') {
      //   return this.$t('home.' + name)
      // }
      return name
    }
  },
  watch: {
    user: {
      handler: function () {
        this.fetchItems()
      },
      deep: true,
      immediate: true
    }
  },
  destroyed () {
    eventBus.$off('refresh')
  }
}
</script>

<style lang="scss" scoped>
.slider-wrapper {
  width: 100%;
  margin-bottom: 50px;
  overflow: hidden;

  .slider-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 30px;

    .category-name {
      font-weight: bold;
      font-size: 16px;
      line-height: 26px;
      letter-spacing: 0.06em;
      color: $main-color;
      text-transform: uppercase;
    }
    .line {
      flex-grow: 1;
      height: 1px;
      background-color: rgba(0, 0, 0, 0.15);
      margin: 0 22px;
    }
    .navigation-btn-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;

      .btn {
        border: 1px solid #efefef;
        height: 26px;
        width: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background: white;
        padding: 0px;

        img {
          // filter: brightness(5);
        }
      }
      .btn:first-child {
        margin-right: 20px;
      }
    }
  }
  .slider-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: auto;
    scroll-behavior: smooth;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none;
  }
  .slider-content::-webkit-scrollbar {
    display: none;
  }
}
.sliders-wrapper .slider-wrapper {
  background: white;
  padding: 20px;
  box-sizing: border-box;
}
</style>
